export const ENDPOINTS = {
  packages: () => `/billing/sale-package`,
  newPackage: () => `/billing/package`,
  payment: () => `/billing/order`,
  approvePayment: (idOrder) => `/billing/order/${idOrder}/paid-order`
};
